import axios from 'axios'

const state = {}
const getters = {}
const mutations = {}

const actions = {
  fetchHubsReport,
  fetchGroupsReport,
  fetchIndividualsReport,
  fetchEventsReport,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

function fetchHubsReport({ commit }, { companyId, from, to }) {
  return axios
    .get(`/api/v1/company_report/${companyId}`, { params: { from, to } })
    .then((response) => {
      const result = response.data
      return result.dataPoints
    })
}

function fetchGroupsReport({ commit }, { companyId, from, to }) {
  return axios
    .get(`/api/v1/groups_report/${companyId}`, { params: { from, to } })
    .then((response) => {
      const result = response.data
      return result.dataPoints
    })
}

function fetchIndividualsReport({ commit }, params) {
  return axios
    .get(`/api/v1/individuals_report/${params.companyId}`, { params })
    .then((response) => {
      const result = response.data
      return result.dataPoints
    })
}

function fetchEventsReport({ commit }, params) {
  return axios
    .get(`/api/v1/events_report/${params.companyId}`, { params })
    .then((response) => {
      const result = response.data
      return result.dataPoints
    })
}
